"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mde = void 0;
const createApi_1 = require("../../helpers/createApi");
const calculateMDE = (caller) => ({ accountId, mdeConfig }) => {
    const searchParams = new URLSearchParams();
    searchParams.set('test_type', `${mdeConfig.testType}`);
    searchParams.set('nb_variations', `${mdeConfig.nbVariations}`);
    mdeConfig.audienceIds.forEach((audienceId) => searchParams.append('audience_ids[]', `${audienceId}`));
    if (mdeConfig.savedPageId) {
        searchParams.set('saved_page_id', `${mdeConfig.savedPageId}`);
    }
    else {
        searchParams.set('url', `${mdeConfig.url}`);
    }
    if (mdeConfig.metricId) {
        searchParams.set('metric_id', `${mdeConfig.metricId}`);
    }
    else {
        searchParams.set('metric_affiliation', `${mdeConfig.metricAffiliation}`);
    }
    return caller(`/backend/accounts/${accountId}/mde?${searchParams.toString()}`).get();
};
const getCampaignMDE = (caller) => ({ accountId, campaignId: testId }) => caller(`/api/v1/accounts/${accountId}/tests/${testId}/mde`).get();
const linkToCampaignMDE = (caller) => ({ accountId, campaignId: testId, mde }) => caller(`/api/v1/accounts/${accountId}/tests/${testId}/mde`).post({ mde });
const patchCampaignMDE = (caller) => ({ accountId, campaignId: testId, mdeId, mde }) => caller(`/api/v1/accounts/${accountId}/tests/${testId}/mde/${mdeId}`).patch({ mde });
const deleteCampaignMDE = (caller) => ({ accountId, campaignId: testId, mdeId }) => caller(`/api/v1/accounts/${accountId}/tests/${testId}/mde/${mdeId}`).delete();
exports.mde = (0, createApi_1.createAPIFactory)({
    calculate: calculateMDE,
    getCampaignMDE,
    linkToCampaign: linkToCampaignMDE,
    patchCampaignLink: patchCampaignMDE,
    deleteCampaignLink: deleteCampaignMDE,
});
//# sourceMappingURL=api.js.map